import { Box, Button, Typography, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { EchoTitle, ReservationCard } from '../..';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        address: {
            color: theme.palette.grey[500],
            fontSize: 16,
            fontWeight: 300,
            margin: '4px 0 9px 0',
            textAlign: 'center',
        },
        btn: {
            marginTop: 40,
            width: 200,
        },
        date: {
            color: theme.palette.primary.light,
            fontSize: 20,
            fontWeight: 'normal',
            marginBottom: 40,
            textAlign: 'center',
        },
        name: {
            color: '#363a43',
            fontSize: 17,
            fontWeight: 'bold',
            letterSpacing: 0.23,
            marginTop: 40,
            textAlign: 'center',
            width: 303,
        },
        price: {
            color: theme.palette.grey[800],
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: 1.5,
            marginBottom: 40,
            textAlign: 'center',
        },
    });
});
export default (function (_a) {
    var title = _a.title, echo = _a.echo, name = _a.name, address = _a.address, date = _a.date, price = _a.price, onNextStep = _a.onNextStep;
    var styles = useStyle({});
    var displayDate = date[0].toUpperCase() + date.substr(1);
    return (React.createElement(ReservationCard, null,
        React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", style: { marginTop: 48 } },
            React.createElement(EchoTitle, { echo: echo, underline: true }, title),
            React.createElement(Typography, { className: styles.name }, name),
            React.createElement(Typography, { className: styles.address }, address),
            React.createElement(Typography, { className: styles.date }, displayDate),
            price && React.createElement(Typography, { className: styles.price },
                "PRIX ",
                price,
                "\u20AC"),
            React.createElement(Button, { className: styles.btn, color: "primary", variant: "contained", onClick: onNextStep }, "Poursuivre"))));
});
//# sourceMappingURL=index.js.map